require("./new_template.coffee");
